import DashboardContext from './DashboardContext'
import General from './General'
import Student from './Student'
import Manager from './Manager'
import DoughnutChart from './DoughnutChart'
import PisaBarChart from './PisaBarChart'
import BarChart from './BarChart'
import dashboardHooks from './hooks'

export { General, Student, Manager, PisaBarChart, BarChart, DoughnutChart, dashboardHooks }
export default DashboardContext